module.exports = "<footer class=\"app-footer\">\n  <span><a href=\"#\">Play X Expense Management</a> &copy; 2018 </span>\n  <span class=\"ml-auto\">Powered by <a href=\"#\">Play X</a></span>\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/app-footer/app-footer.component.html
// module id = ./src/app/components/app-footer/app-footer.component.html
// module chunks = main